import { InjectionToken } from '@angular/core';

export enum Features {
  VAKI_SITES = 'vaki-sites',
  VAKI_GIFTS = 'vaki-gifts',
  VAKI_SPONSORS = 'vaki-sponsors',
  ALGOLIA_RECOMMEND = 'algolia-recommend' // Only available in production
}
export type Feature = `${Features}`;
export type FeatureConfig = {
  [key in Feature]: boolean;
};

export const APP_ID = new InjectionToken<string>('appVersion');
export const ALGOLIA_API_KEY = new InjectionToken<string>('algoliaApiKey');
export const ALGOLIA_APP_ID = new InjectionToken<string>('algoliaApiKey');
export const ALGOLIA_VAKI_INDEX = new InjectionToken<string>(
  'algoliaVakisIndex'
);
export const API_URL = new InjectionToken<string>('apiUrl');
export const API_VAKI_URL = new InjectionToken<string>('apiVakiUrl');
export const HOST_URL = new InjectionToken<string>('hostUrl');
export const CRYPTO_LANDING_URL = new InjectionToken<string>(
  'cryptoLandingUrl'
);
/** See `Environment.lolaCreateVakiUrl`'s doc comment. */
export const LOLA_CREATE_VAKI_URL = new InjectionToken<string>(
  'lolaCreateVakiUrl'
);
import { Environment } from './environment.interface';

export const ENVIRONMENT = new InjectionToken<Environment>('environment');
export const MP_NOTIFICATION_URL = new InjectionToken<string>(
  'mpNotificationUrl'
);
export const MP_API_KEY = new InjectionToken<string>('mpApiKey');
export const STRIPE_KEY = new InjectionToken<string>('stripeKey');
export const STRIPE_KEY_MX = new InjectionToken<string>('stripeKeyMx');
export const FEATURE_FLAGS = new InjectionToken<FeatureConfig>('featureFlags');
export const PAYPAL_MX_CLIENT_ID = new InjectionToken<string>(
  'paypalMxClientId'
);
export const PRIVY_APP_ID = new InjectionToken<string>('privyAppId');
export const PLATFORM_HASH = new InjectionToken<string>('platformHash');
export const CAMPAIGN_INFO_FACTORY_ADDRESS = new InjectionToken<string>(
  'campaignInfoFactoryAddress'
);
export const PLEDGE_TOKEN_ADDRESS = new InjectionToken<string>(
  'pledgeTokenAddress'
);
export const CHAIN_ID = new InjectionToken<string>('chainId');
export const RPC_URL = new InjectionToken<string>('rpcUrl');
export const PLATFORM_ADMIN_WALLET_ADDRESS = new InjectionToken<string>(
  'platformAdminWalletAddress'
);
export const IS_PRODUCTION = new InjectionToken<boolean>('isProduction');
export const INTERCOM_APP_ID = new InjectionToken<string>('intercomAppId');
export const SIIGO_FV_ID = new InjectionToken<number>('siigoFvId');
export const SIIGO_SELLER_ID = new InjectionToken<number>('siigoSellerId');
export const SIIGO_PAYMENT_METHOD = new InjectionToken<number>(
  'siigoPaymentMethod'
);
export const SIIGO_PRODUCT_CODE = new InjectionToken<string>(
  'siigoProductCode'
);
